import { Card } from "primereact/card";
import styles from "../sitedsti.module.scss";
import { Checkbox } from "primereact/checkbox";
import { DSTIRecord } from "../../../../models/DSTI/site-dsti-list.interface";
import { BasicOption, DtpInterface, RichOption } from "../../../../models/DSTI/site-dsti.interface";

interface TaskAndEquipmentProps {
  details?: DSTIRecord | DtpInterface;
  canEdit?: boolean;
  handleChange?: (
    value: BasicOption | RichOption,
    type: "task" | "equipment" | "chemical" | "vehicle"
  ) => void;
}

function TaskAndEquipment({ details, canEdit = false, handleChange }: TaskAndEquipmentProps) {
  return (
    <>
      <Card title={"Tasks"}>
        <div className={styles["responsive-grid-2"]}>
          {details?.task &&
            details?.task.options?.map((task, index) => {
              return (
                <div key={index} className="flex align-items-center gap-2">
                  <Checkbox
                    inputId={`task-${index}`}
                    checked={task.check}
                    disabled={!canEdit}
                    onChange={e => {
                      if (canEdit) {
                        handleChange?.({ ...task, check: e.checked || false }, "task");
                      }
                    }}
                  />
                  <label htmlFor={`task-${index}`}>{task.name}</label>
                </div>
              );
            })}
        </div>
      </Card>
      {details?.equipment &&
        details?.equipment.options &&
        details?.equipment.options?.length > 0 && (
          <div className={"mt-4"}>
            <h2>Equipment</h2>
            <div className={styles["responsive-grid-4"]}>
              {details?.equipment.options?.map((equipment, index) => {
                return (
                  <div key={index} className={styles["equipment-container"]}>
                    <div style={{ position: "relative" }} className={styles["checkbox-container"]}>
                      <img
                        src={
                          equipment.photo ||
                          "https://ionicframework.com/docs/img/demos/thumbnail.svg"
                        }
                        alt={equipment.name}
                        onError={e => {
                          e.currentTarget.src =
                            "https://ionicframework.com/docs/img/demos/card-media.png";
                        }}
                        style={{
                          width: "150px",
                          height: "150px",
                          objectFit: "cover",
                        }}
                      />
                      <Checkbox
                        inputId={`equipment-${index}`}
                        checked={equipment.check}
                        className={styles["checkbox-container-input"]}
                        disabled={!canEdit}
                        onChange={e => {
                          if (canEdit) {
                            handleChange?.(
                              { ...equipment, check: e.checked || false },
                              "equipment"
                            );
                          }
                        }}
                        style={{
                          position: "absolute",
                          top: 2,
                          left: 4,
                        }}
                      />
                    </div>
                    <p>{equipment.name}</p>
                  </div>
                );
              })}
            </div>
          </div>
        )}

      {details?.vehicle && details?.vehicle.options && details?.vehicle.options.length > 0 && (
        <div className={"mt-4"}>
          <h2>Vehicles</h2>
          <div className={styles["responsive-grid-4"]}>
            {details?.vehicle.options.map((vehicle, index) => {
              return (
                <div key={index} className={styles["equipment-container"]}>
                  <div style={{ position: "relative" }} className={styles["checkbox-container"]}>
                    <img
                      src={
                        vehicle.photo || "https://ionicframework.com/docs/img/demos/thumbnail.svg"
                      }
                      alt={vehicle.name}
                      onError={e => {
                        e.currentTarget.src =
                          "https://ionicframework.com/docs/img/demos/card-media.png";
                      }}
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                      }}
                    />
                    <Checkbox
                      inputId={`vehicle-${index}`}
                      checked={vehicle.check}
                      className={styles["checkbox-container-input"]}
                      disabled={!canEdit}
                      onChange={e => {
                        if (canEdit) {
                          handleChange?.({ ...vehicle, check: e.checked || false }, "vehicle");
                        }
                      }}
                      style={{
                        position: "absolute",
                        top: 2,
                        left: 4,
                      }}
                    />
                  </div>
                  <p>{vehicle.name}</p>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {details?.chemical && details?.chemical.options && details?.chemical.options.length > 0 && (
        <div className={"mt-4"}>
          <h2>Chemicals</h2>
          <div className={styles["responsive-grid-4"]}>
            {details?.chemical.options.map((chemical, index) => {
              return (
                <div key={index} className={styles["equipment-container"]}>
                  <div style={{ position: "relative" }} className={styles["checkbox-container"]}>
                    <img
                      src={
                        chemical.photo || "https://ionicframework.com/docs/img/demos/thumbnail.svg"
                      }
                      alt={chemical.name}
                      onError={e => {
                        e.currentTarget.src =
                          "https://ionicframework.com/docs/img/demos/card-media.png";
                      }}
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                      }}
                    />
                    <Checkbox
                      inputId={`chemical-${index}`}
                      checked={chemical.check}
                      className={styles["checkbox-container-input"]}
                      disabled={!canEdit}
                      onChange={e => {
                        if (canEdit) {
                          handleChange?.({ ...chemical, check: e.checked || false }, "chemical");
                        }
                      }}
                      style={{
                        position: "absolute",
                        top: 2,
                        left: 4,
                      }}
                    />
                  </div>
                  <p>{chemical.name}</p>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}

export default TaskAndEquipment;
